import React, { Component } from 'react';
import {Table, DatePicker, Input, Button, Popconfirm } from 'antd';
import moment from 'moment';

class EditableCell extends Component {
    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    handleDateChange = (date, dateString) => {
        this.props.onChange(dateString);
    }
 
    getContent = () => {
        const { type, value, typeProperty } = this.props;
        const { disabledDate = function() {} } = typeProperty || {};
        if (type === 'input') {
            return (
                <Input
                    value={value}
                    placeholder='请输入'
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            )
        } else if (type === 'datePicker') {
            return (
                <DatePicker
                    placeholder='请选择'
                    style={{ width: '100%' }}
                    disabledDate={disabledDate}
                    value={value ? moment(value) : null}
                    onChange={this.handleDateChange}
                />
            )
        }
    }

    render () {
        return this.getContent();
    }
}

class EditableTable extends Component {
    handleAdd = () => {
        const { dataSource, onChange } = this.props;
        dataSource.push({});
        onChange(dataSource);
    }

    handleDelete = (index) => {
        const { dataSource, onChange } = this.props;
        dataSource.splice(index, 1);
        onChange(dataSource);
    }

    handleChange = (value, key, index) => {
        const { dataSource, onChange } = this.props;
        const target = dataSource[index];
        target[key] = value;
        onChange(dataSource);
    }

    getColumns = () => {
        const { canEdit, columns } = this.props;
        const result = [];
        columns.forEach(column => {
            const { name, key, type, typeProperty, rules } = column;
            const { style } = typeProperty || {};
            const { width } = style || {};
            const { display = true } = rules || {};
            if (display) {
                result.push({
                    title: name,
                    dataIndex: key,
                    key,
                    width,
                    render: (text, record, index) => {
                        return (
                            canEdit ?
                                <EditableCell
                                    type={type}
                                    value={text}
                                    typeProperty={typeProperty}
                                    onChange={value => this.handleChange(value, key, index)}
                                />
                            :
                                text
                        )
                    }
                })
            }
        });
        if (canEdit) {
            result.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 60,
                render: (text, record, index) => {
                    return (
                        <Popconfirm title="确定删除该记录?" onConfirm={() => this.handleDelete(index)}>
                            <a>删除</a>
                        </Popconfirm>
                    )
                }
            });
        }
        return result;
    }

    // 重新计算key值，防止重复
    getDataSource = () => {
        const { dataSource } = this.props;
        const data = (dataSource || []).map((item, index) => {
            return {
                key: index,
                ...item,
            };
        });
        return data;
    }

    computeWidth = (list) => {
        let w = 0;
        list.forEach(item => {
            const { width, children } = item;
            if (children && Array.isArray(children)) {
                w += this.computeWidth(children);
            } else {
                w += width;
            }
        });
        return w;
    }

    render() {
        const { canEdit, scrollY } = this.props;
        const columns = this.getColumns();
        let scrollX = this.computeWidth(columns);
        // 列表字段的width没设时，scrollX为NaN，此时默认不能左右滚动
        if (scrollX !== scrollX) {
            scrollX = false;
        } else {
            scrollX += scrollY > 0 ? 0 : 0;
        }
        return (
            <div>
                {canEdit && <Button type="ghost" style={{marginBottom: 10}} onClick={this.handleAdd}>添加</Button> }
                <Table
                    bordered
                    columns={columns}
                    dataSource={this.getDataSource()}
                    scroll={{x: scrollX, y: scrollY }}
                    pagination={false}
                />
            </div>
        );
    }
}

export default EditableTable;


// WEBPACK FOOTER //
// ./src/components/common/EditableTable.js